import { formatDuration, formatPrice } from '../../lib/format';
import type { BreakthroughAssessment } from '../../types/market';
import { Badge } from '../ui/Badge';
import { Panel } from '../ui/Panel';

export function BreakthroughPanel({ breakthrough }: { breakthrough: BreakthroughAssessment }): React.JSX.Element {
  const tone = breakthrough.direction === 'long' ? 'positive' : breakthrough.direction === 'short' ? 'negative' : 'neutral';
  return (
    <Panel
      title="Adaptive historical breakthrough"
      description="The chart discovers meaningful history depth; no fixed candle-count rule is treated as universal."
      action={<Badge tone={tone}>{breakthrough.state.replace('-', ' ')}</Badge>}
    >
      <dl className="info-list">
        <div className="info-row"><dt>Direction</dt><dd>{breakthrough.direction}</dd></div>
        <div className="info-row"><dt>Adaptive history spanned</dt><dd>{breakthrough.candlesSurpassed} candles</dd></div>
        <div className="info-row"><dt>Historical duration</dt><dd>{formatDuration(breakthrough.durationMs)}</dd></div>
        <div className="info-row"><dt>Boundary strength</dt><dd>{breakthrough.boundaryStrength.toFixed(0)}/100</dd></div>
        <div className="info-row"><dt>Boundary</dt><dd>{breakthrough.boundary ? `$${formatPrice(breakthrough.boundary)}` : 'Not broken'}</dd></div>
        <div className="info-row"><dt>Penetration</dt><dd>{breakthrough.penetrationPercent.toFixed(2)}%</dd></div>
        <div className="info-row"><dt>Body acceptance</dt><dd>{breakthrough.acceptancePercent.toFixed(1)}%</dd></div>
        <div className="info-row"><dt>Next historical boundary</dt><dd>{breakthrough.nextHistoricalBoundary ? `$${formatPrice(breakthrough.nextHistoricalBoundary)}` : 'Not found in loaded history'}</dd></div>
      </dl>
      <div className="attribution-list"><div className="notice">{breakthrough.explanation}</div></div>
    </Panel>
  );
}
